import React from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';

export default function BlogType({
  menu,
  additionalData,
}: componentTypes.MenuProps) {
  const { items, refine } = menu;

  const { blogs } = additionalData;

  const hasRefinedItem = items.filter((item) => item.isRefined).length > 0;

  return (
    <div className="hidden lg:flex-1.0 lg:flex flex-wrap gap-3">
      <label
        key="all"
        className="inline-flex justify-center items-center text-base leading-none font-semibold rounded transition-all bg-transparent text-near-black border border-light-grey-2 px-4 pt-4.5 pb-4.6 cursor-pointer hover:border-near-black has-[:checked]/label:bg-near-black has-[:checked]/label:border-black has-[:checked]/label:text-white"
        htmlFor="all"
      >
        {Craft.t(blogs, 'Alles')}
        <input
          id="all"
          value=""
          className="absolute opacity-0"
          type="radio"
          name="blogType"
          checked={!hasRefinedItem}
          onChange={() => refine('')}
        />
      </label>
      {items.map((item) => (
        <label
          key={item.value}
          className="inline-flex justify-center items-center text-base leading-none font-semibold rounded transition-all bg-transparent text-near-black border border-light-grey-2 px-4 pt-4.5 pb-4.6 cursor-pointer hover:border-near-black has-[:checked]/label:bg-near-black has-[:checked]/label:border-black has-[:checked]/label:text-white"
          htmlFor={item.value}
        >
          {item.label}
          <input
            id={item.value}
            value={item.value}
            className="absolute opacity-0"
            type="radio"
            name="blogType"
            checked={item.isRefined}
            onChange={() => refine(item.value)}
          />
        </label>
      ))}
    </div>
  );
}
